import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import { Message } from 'semantic-ui-react';

import { campaignStatus, getCampaignStatus } from '../../utils/campaign-status';

const LiveBanner = ({ campaign }) => {
  const status = getCampaignStatus(campaign);
  const startDate = moment(_.get(campaign, 'liveDate')).format('LL');
  const endDate = moment(_.get(campaign, 'endDate')).format('LL');

  if (status === campaignStatus.LIVE) {
    return (
      <Message success icon="play circle outline" header="This campaign is LIVE" content={`End date: ${endDate}.`} />
    );
  }
  if (status === campaignStatus.FUTURE) {
    return (
      <Message color="orange" icon="wait" header="This campaign has NOT STARTED yet" content={`Start date: ${startDate}.`} />
    );
  }
  if (status === campaignStatus.COMPLETED) {
    return (
      <Message color="orange" icon="flag" header="This campaign is COMPLETE" content={`End date: ${endDate}.`} />
    );
  }
  return (
    <Message color="orange" icon="warning circle" header="Campaign is not tracking." content="Live or end date is not set." />
  );
};

LiveBanner.propTypes = {
  campaign: PropTypes.shape({
    liveDate: PropTypes.string,
    endDate: PropTypes.string,
  }).isRequired,
};

export default LiveBanner;



/** WEBPACK FOOTER **
 ** ./src/containers/large-campaign/live-banner.js
 **/